import Raven from 'raven-js';

Raven
  .config(`https://c0f3684819fd49e3bfefdfaebc7e6c8d@${window.location.hostname}/_sentry/62`, {
    whitelistUrls: [
      /https?:\/\/.*semrush\.com/,
      /https?:\/\/d1s2bi6s2ke6kd\.cloudfront\.net/,
    ],
    includePaths: [
      /https?:\/\/.*semrush\.com/,
      /https?:\/\/d1s2bi6s2ke6kd\.cloudfront\.net/,
    ]
  })
  .install();

export default function(options) {
  import('./style/main.scss');
  import('./init.js').then(View => new View.default(options));
}